import { render, staticRenderFns } from "./news-center.vue?vue&type=template&id=19676ea5&scoped=true"
import script from "./news-center.vue?vue&type=script&lang=js"
export * from "./news-center.vue?vue&type=script&lang=js"
import style0 from "./news-center.vue?vue&type=style&index=0&id=19676ea5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19676ea5",
  null
  
)

export default component.exports